var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "visually-hidden" }, [
      _c(
        "svg",
        {
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 16 16"
          }
        },
        [
          _c("g", { attrs: { id: "sort_desc" } }, [
            _c("polygon", {
              attrs: {
                stroke: "#000000",
                "stroke-miterlimit": "10",
                points: "8,2 1.1,14 14.9,14"
              }
            })
          ]),
          _vm._v(" "),
          _c("g", { attrs: { id: "sort_asc" } }, [
            _c("polygon", {
              attrs: {
                stroke: "#000000",
                "stroke-miterlimit": "10",
                points: "8,14.5 14.9,2.5 1.1,2.5"
              }
            })
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("TablePeople", {
          attrs: {
            sortedPeople: _vm.sortedPeople,
            sortBy: _vm.sortBy,
            asc: _vm.asc
          },
          on: { sortPersons: _vm.setSortConfiguration }
        }),
        _vm._v(" "),
        _c("NewPeopleForm", { on: { add_person: _vm.addPerson } })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("h1", [_vm._v("Table on Vue")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bced26ea", { render: render, staticRenderFns: staticRenderFns })
  }
}